import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbarttt.css";
import logo from "../image/logo.png";
import startup from "../image/startup.png";
import { FaBars, FaTimes } from "react-icons/fa";
import { MdAdminPanelSettings } from "react-icons/md";

function Navbarttt() {

  const location = useLocation();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminAccess, setAdminAccess] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  // ✅ Sync admin login state
  useEffect(() => {
    const adminStatus = localStorage.getItem("isAdmin");
    const accessStatus = localStorage.getItem("adminAccess");

    setIsAdmin(adminStatus === "true");
    setAdminAccess(accessStatus === "true");
  }, [location]);

  // ✅ Logout
  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    setIsAdmin(false);
    closeMenu();
    navigate("/");
  };

  return (
    <nav className="navbar fade-in-top">
      <div className="navbar-container">

        {/* LOGO */}
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="Logo" className="logo-image" />
          </Link>
          <img src={startup} alt="Startup" className="startup-logo-image" />
        </div>

        {/* MENU ICON */}
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <div className={`navbar-content ${menuOpen ? "active" : ""}`}>

          {/* LINKS */}
          <ul className="navbar-links">
            <li><Link to="/" onClick={closeMenu}>Home</Link></li>
            <li><Link to="/about" onClick={closeMenu}>About Us</Link></li>
            <li><Link to="/services" onClick={closeMenu}>Services</Link></li>
            <li><Link to="/products" onClick={closeMenu}>Products</Link></li>
            <li><Link to="/view-certification" onClick={closeMenu}>Certificates</Link></li>
          </ul>

          {/* BUTTONS */}
          <div className="navbar-buttons">

            {/* ADMIN LOGIN */}
            {adminAccess && !isAdmin && (
              <Link to="/login" onClick={closeMenu} className="btn login-btn">
                Admin Login
              </Link>
            )}

            {/* AFTER LOGIN */}
            {isAdmin && (
              <>
                {/* 🔥 ADMIN DROPDOWN */}
                <div className="admin-menu">
                  <MdAdminPanelSettings size={28} />

                  <div className="admin-dropdown">
                    <Link to="/admin-1" onClick={closeMenu}>
                      Admin-1
                    </Link>
                    <Link to="/admin-2" onClick={closeMenu}>
                      Admin-2
                    </Link>
                  </div>
                </div>

                {/* LOGOUT */}
                <button onClick={handleLogout} className="btn logout-btn">
                  Logout
                </button>
              </>
            )}

            {/* CONTACT */}
            <Link
              to="/contact"
              onClick={closeMenu}
              className="btn contact-btn"
            >
              Contact Us
            </Link>

          </div>

        </div>
      </div>
    </nav>
  );
}

export default Navbarttt;